/* unplugin-vue-components disabled */import { render } from "./GxDialog.vue?vue&type=template&id=3f6af71a&scoped=true&ts=true"
import script from "./GxDialog.vue?vue&type=script&lang=ts"
export * from "./GxDialog.vue?vue&type=script&lang=ts"

import "./GxDialog.vue?vue&type=style&index=0&id=3f6af71a&lang=scss"
import "./GxDialog.vue?vue&type=style&index=1&id=3f6af71a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6af71a"]])

export default __exports__